// import React from 'react'
// import Div from '../Div'
// import './funfact.scss'

// export default function FunFact({variant, title, subtitle, data}) {
//   return (
//     <Div className={variant ? `cs-funfact_wrap ${variant}`: 'cs-funfact_wrap'}>
//       <Div className="cs-funfact_shape"  style={{backgroundImage: 'url(./images/funfact_shape_bg.svg)'}} />
//       <Div className="cs-funfact_left">
//         <Div className="cs-funfact_heading">
//           <h2>{title}</h2>
//           <p>{subtitle}</p>
//         </Div>
//       </Div>
//       <Div className="cs-funfact_right">
//         <Div className="cs-funfacts">
//         {data.map((item, index) => (
//           <Div className="cs-funfact cs-style1" key={index}>
//             <Div className="cs-funfact_number cs-primary_font cs-semi_bold cs-primary_color"><span/>{item.factNumber}</Div>
//             <Div className="cs-funfact_text">
//               <span className="cs-accent_color">+</span>
//               <p>{item.title}</p>
//             </Div>
//           </Div>
//           ))}
//         </Div>
//       </Div>
//     </Div>
//   )
// }
import React, { useEffect, useState } from "react";
import Odometer from "react-odometerjs";
import { useInView } from "react-intersection-observer";
import Div from "../Div";
import "./funfact.scss";

export default function FunFact2({ data, variant, bgUrl }) {
  return (
    <Div className={variant ? `cs-funfact_wrap_2 ${variant}` : "cs-funfact_wrap_2"}>
      {bgUrl && (
        <div className="cs-funfact_shape" style={{ backgroundImage: `url(${bgUrl})` }}></div>
      )}

      <Div className="cs-funfacts">
        {data.map((item, index) => (
          <CountBox key={index} item={item} />
        ))}
      </Div>
    </Div>
  );
}

function CountBox({ item }) {
  const { ref, inView } = useInView({ triggerOnce: true, threshold: 0.3 });
  const [value, setValue] = useState(item.startNumber);

  useEffect(() => {
    if (inView) {
      setTimeout(() => {
        setValue(item.endNumber); // slow slide to this number
      }, 500);
    }
  }, [inView, item.endNumber]);

  return (
    <Div ref={ref} className="cs-funfact cs-style2 fade-slide">
      <Div className="cs-funfact_number glow-number cs-primary_font cs-semi_bold cs-primary_color">

        <Odometer
          value={value}
          format="(ddd)"  // format numbers
          duration={item.speed * 1000 || 3000}  // ⭐ Adjust slow speed here
        />

        <span className="cs-plus">{item.suffix}</span>
      </Div>

      <h3 className="cs-funfact_title fade-text">{item.title}</h3>
    </Div>
  );
}






  